import React from 'react'
import Field from '../../views/widgets/Field'
import styled from 'styled-components'

class WebTransferFormNotes extends React.Component {
  state = {
    isShowComponent: true,
  }

  handleToggleShow = () => {
    this.setState({
      isShowComponent: !this.state.isShowComponent,
    })
  }

  render() {
    return (
      <WebTransferFormNotesView
        notes={this.props.notes}
        isShow={this.state.isShowComponent}
        onToggleShow={this.handleToggleShow}
      />
    )
  }
}

const WebTransferFormNotesView = ({ notes, isShow, onToggleShow }) => (
  <Field label="Notes" isHorizontal={false}>
    {isShow && (
      <div className="content">
        <Blockquote>{notes}</Blockquote>
      </div>
    )}
    <p className="has-text-right">
      <LinkComponent onClick={onToggleShow}>
        {isShow ? 'hide notes' : 'show notes'}
      </LinkComponent>
    </p>
  </Field>
)

const LinkComponent = styled.a`
  text-decoration: underline;
`

const Blockquote = styled.blockquote`
  white-space: pre-line;
`

export default WebTransferFormNotes



// WEBPACK FOOTER //
// ./src/components/templates/webTransferInfo/WebTransferFormNotes.js